import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BankAccountDto } from 'src/app/domain/models/dto/bank-account.dto';
import { BankDashDto, BankDto } from 'src/app/domain/models/dto/bank.dto';
import { ContactAccountDto } from 'src/app/domain/models/dto/contact-account.dto';
import { DemeBankDto } from 'src/app/domain/models/dto/deme-bank.dto';
import { ResponseObjectModel } from 'src/app/domain/models/response-object.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BankAccountService {
  private listener: BehaviorSubject<boolean> = new BehaviorSubject(null);
  constructor(private http: HttpClient) {}

  get listenerUpdate() {
    return this.listener.asObservable();
  }

  updateBankAccountsView() {
    this.listener.next(true);
  }

  addBankAccount(bankAccount: BankAccountDto | ContactAccountDto) {
    return this.http.post<
      ResponseObjectModel<BankAccountDto | ContactAccountDto>
    >(`${environment.API_BASE_URL}/v1/account-banks`, bankAccount);
  }

  editBankAccount(bankAccount: BankAccountDto | ContactAccountDto) {
    return this.http.put<BankAccountDto | ContactAccountDto>(
      `${environment.API_BASE_URL}/v1/account-banks/${bankAccount?.id}`,
      bankAccount
    );
  }

  updateBankAccount(bankAccount: BankAccountDto) {
    return this.http.put<BankAccountDto>(
      `${environment.API_BASE_URL}/v1/account-banks/${bankAccount.id}`,
      bankAccount
    );
  }

  defaultAccount(bankAccountId: number) {
    return this.http.put<BankAccountDto>(
      `${environment.API_BASE_URL}/v1/account-banks/${bankAccountId}/default`,
      bankAccountId
    );
  }

  deleteAccount(bankAccountId: number) {
    return this.http.delete<any>(
      `${environment.API_BASE_URL}/v1/account-banks/${bankAccountId}`
    );
  }

  getAll() {
    return this.http.get<ResponseObjectModel<BankAccountDto[]>>(
      `${environment.API_BASE_URL}/v1/account-banks`
    );
  }

  get(id: number) {
    return this.http.get<ResponseObjectModel<BankAccountDto>>(
      `${environment.API_BASE_URL}/v1/bank-accounts/${id}`
    );
  }

  getAllSendersandReceivers(contactType?: string, currency?: string) {
    let filterParams = '';

    if (contactType) {
      filterParams += `?type=${encodeURIComponent(contactType)}`;
    }
    if (currency) {
      filterParams += `&currency=${encodeURIComponent(currency)}`;
    }

    return this.http.get<ResponseObjectModel<any>>(
      `${environment.API_BASE_URL}/v1/account-banks/sender-receivers${filterParams}`
    );
  }

  getBanks() {
    return this.http.get<ResponseObjectModel<BankDto[]>>(
      `${environment.API_BASE_URL}/v1/banks`
    );
  }

  getDemeBanks(currency: string) {
    return this.http.get<ResponseObjectModel<DemeBankDto[]>>(
      `${environment.API_BASE_URL}/v1/deme-banks?currency=${currency}`
    );
  }

  getNewBanks() {
    return this.http.get<ResponseObjectModel<BankDashDto[]>>(
      `${environment.API_BASE_URL}/v1/dashboard-integration/get-bank-list`
    );
  }

  getDashBanks() {
    return this.http.get<ResponseObjectModel<BankDashDto[]>>(
      `${environment.API_DASH_BASE_URL}/Integration/bank/list`
    );
  }
}
